import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

interface UseDeletePatronStateParams {
  patronId: number
  stateId: number
}

interface UseDeletePatronStateProps {
  onSuccess?: (data: undefined, variables: UseDeletePatronStateParams) => void
  onError?: (error: Error, variables: UseDeletePatronStateParams) => void
}

export const useDeletePatronState = ({
  onSuccess,
  onError,
}: UseDeletePatronStateProps): UseMutationResult<
  undefined,
  Error,
  UseDeletePatronStateParams
> => {
  const deletePatronState = useTypedApiClient({
    path: '/admin/patron/{patronId}/delete-state/{stateId}',
    method: 'delete',
  })

  const queryClient = useQueryClient()

  return useMutation<undefined, Error, UseDeletePatronStateParams>({
    mutationFn: async ({ patronId, stateId }: UseDeletePatronStateParams) => {
      await deletePatronState({
        patronId,
        stateId,
      })
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/patron/{patronId}/states'],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
